import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ImageHover, Section, Timer, EventListItem, Winners, HoverItem } from '../../components';
import { switchApplyPopup, applyUserCode } from '../../actions';
import { Player, BigPlayButton } from 'video-react';
import Slider from 'react-slick';
import "./styles.css"

class Invites extends Component{
  componentWillMount(){
    console.log("Invites::", this.props.match.params.userCode);
    this.props.dispatch(switchApplyPopup(true));
    this.props.dispatch(applyUserCode(this.props.match.params.userCode));
  }
  render(){
    const settings = {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow className='arrow-prev' />,
      prevArrow: <SamplePrevArrow className='arrow-next' />
    };
    return (
      <div>
        <div className="home-background"><img alt="header" src="/img/home-header.jpg" /></div>
        <Section className="secition-main-home">
            <div>
              <div>
                <ImageHover image='/img/home-slice-1.jpg' hoverComponent={
                    <HoverItem headerClassNames={['different-class-name']} number="CONSUMERS ARE AT THE HEART OF EVERYTHING WE DO." redNumber="TECHNOLOGY IS OUR PASSION." heading="We're here to hack the future. Are you with us?" text="Join the adidas team on a tech journey across Europe via a series of thought-provoking hackathon challenges. You’ll have the chance to play with cutting-edge technologies, meet our talented engineers and ideate with top digital leaders."/>
                  }>
                </ImageHover>
              </div>
              <div>
                <div className="title-adidas-hackathons">
                  <div className="line-1">#HereToCreate</div>
                  <div className="line-2">2018 ADIDAS HACKATHONS</div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <ImageHover image='/img/home-slice-2.jpg' hoverComponent={
                  <HoverItem number="FIVE" heading="Locations" text="Barcelona, Sofia, Madrid, Amsterdam and Herzogenaurach."/>
                }/>
              </div>
              <div>
                <ImageHover image='/img/home-slice-3.jpg' hoverComponent={
                  <HoverItem number="FOUR" heading="Local Hackathons" text="The clock is ticking – Your challenge is to win a local hackathon in less than 48 hours."/>
                }/>
              </div>
            </div>
            <div>
              <div><Timer /></div>
              <div>
                <ImageHover image='/img/home-slice-4.jpg' hoverComponent={
                  <HoverItem number="ONE" heading="global winner" text="One team becomes the global Champ at the adidas HQ Final in Germany!"/>
                } />
              </div>
            </div>
        </Section>

        <Section className="section-video">
          <div>
            <Player
              poster="/img/video.png"
              src="/here-to-create.mp4"
            >
              <BigPlayButton position="center" />
            </Player>
          </div>
          <div>
            <img className="img-here-to-create" src="/img/here-to-create.png"  alt="Here to Create" />
          </div>
        </Section>
        <Section className="full-img-banner">
          <img src="/img/adidas-full-img-1.jpg" alt="addida-full"/>
        </Section>
        <Section className="section-about">
          <div className="flex">
            <div className="bg-red flex"><h2>About</h2></div>
          </div>
          <div>
            <p>So, you’re a software engineer, or maybe a student, or an innovator. And you’re passionate about the intersection of technology and sport too? Hmmm, well then you're just the creator we’re looking for. We want great minds like you to come, experiment and dream big with us. Through our cutting-edge technology stack, you'll get to combine different technologies like IoT devices, sensors, location-based services, big data, AI, and many others.</p>
            <ul>
              <li>Choose one location out of the four adidas hacking hubs across Europe</li>
              <li>Apply either with your team or alone</li>
              <li>If you get in, the challenge is on: win your local hackathon in less than 48 hours.</li>
              <li>The winning team from each location will qualify for the final competition, taking place at the adidas global HQ in Germany. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package.</li>
            </ul>
          </div>
        </Section>
        <Section className="full-width section-challenges-and-locations">
          <div>
            <h2><span className="color-red">CHALLENGES</span> &amp; LOCATIONS</h2>
            <div className="flex">
              <div>
                <div className="EventListItem-wrap">
                  {this.props.events.map((ev, key) => {
                    return (
                      <EventListItem key={key} location={ev.location} title={ev.description} date={ev.fromToDate}/>
                    )
                  })}
                </div>
              </div>
              <div className="winners-wrap">
                <Winners />
              </div>
            </div>
          </div>
        </Section>
        <Section className="full-width full-width-red-white">
          <div className="flex">
            <div>
              <h5 className="uppercase">Here at adidas, we believe that</h5>
              <h2 className="nospace">
                through sport,<br/>
                we have the<br/>
                power to<br/>
                change lives.
              </h2>
            </div>
            <div>
              <p>To change lives, we must build direct relationships with our consumers. The best way to create this kind of relationship is through digital. To do that, we play agile, learn fast, play by team principles and soar past limits. We break boundaries through internal hackathons- bringing players together with various skills & focus areas. We lock ourselves in the room with our tools, our creativity and our passion and the timer begins. We build the prototypes in 8 hours…not 8 weeks, just one day. This is how we accelerate in digital.</p>
              <p><strong>Now we're opening our culture so you can experience this exciting way of working with us!</strong></p>
            </div>
          </div>
        </Section>
        <Section className="full-img-banner nospace-top">
          <img src="/img/adidas-full-img-2.jpg" alt="adidas-full"/>
        </Section>
        <Section className="section-past-hackathons">
          <div>
            <h2><span className="color-red">PAST</span><br/>HACKATHONS</h2>
            <p className="nospace-bottom">In the past years, adidas has participated and organized many hackathons. Combining artificial intelligence, smart devices, sensors, VR, AR, participants developed various innovative working solutions and prototypes.</p>
          </div>
          <div>
            <Slider {...settings}>
              <img src='/past-hackathons/past-hackathons-15.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-1.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-2.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-4.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-5.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-6.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-7.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-8.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-9.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-10.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-11.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-12.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-13.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-16.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-17.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-19.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-21.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-22.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-23.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-24.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-25.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-26.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-27.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-28.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-29.jpg' alt=""/>
              <img src='/past-hackathons/past-hackathons-30.jpg' alt=""/>
            </Slider>
          </div>
        </Section>
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style}}
      onClick={onClick}
    ></div>
  );
}

function SamplePrevArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style}}
      onClick={onClick}
    ></div>
  );
}

const mapStateToProps = (state) => {
  return {
    modal: state.apply,
    events: state.challenges.data
  }
}

export default connect(mapStateToProps)(Invites);



// WEBPACK FOOTER //
// ./src/screens/Invites/Invites.js